module.exports = __webpack_public_path__ + "static/img/info-health.cceea707.png";